import { render, staticRenderFns } from "./DeployDispatch.vue?vue&type=template&id=47a3a62e&scoped=true"
import script from "./DeployDispatch.vue?vue&type=script&lang=js"
export * from "./DeployDispatch.vue?vue&type=script&lang=js"
import style0 from "./DeployDispatch.vue?vue&type=style&index=0&id=47a3a62e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a3a62e",
  null
  
)

export default component.exports